// PageDetail Component

import React from 'react'
import classnames from 'classnames'

import app from '../../../app.jsx'
import Sidebar from '../../../common/layout/sidebar/sidebar.jsx'
import DateUtil from '../../../lib/dateutil.jsx'
import Acl from '../../../lib/acl.jsx'
import PageBase from '../../../common/page/page_base/page_base.jsx'
import DemoButton from '../../../common/common/demo_button/demo_button.jsx'
import DialogAlert from '../../../common/dialog/dialog_alert/dialog_alert.jsx'
import Alert from '../../../common/common/alert/alert.jsx'
import DialogTrail from '../../../common/dialog/dialog_trail/dialog_trail.jsx'
import SidebarUtil from '../../../lib/sidebarutil.jsx'

class PageDetail extends PageBase {
  constructor (props, pageIdent, sidebarIdent) {
    super(props, pageIdent, sidebarIdent, '')

    this._sidebarIdent = sidebarIdent
    this._pageIdent = pageIdent
    this._showPlanner = false
    this._bUnMounted = false
    this._showRightSidebar = false
    this._eventHandlers = {}

    // Get config
    const config = app.getConfig()
    if (config) {
      this._enableFbq = !!(config.fbq && config.fbq.enabled)
      this._showPlanner = config.showPlanner
    }
  }

  componentWillUnmount () {
    this._bUnMounted = true
  }

  render () {
    return this.renderDetailPageContent()
  }

  renderDefaultPageContent () {
    return super.render()
  }

  renderDetailPageContent () {
    const bMultipleTeams =
      this._pageData.userTeams && this._pageData.userTeams.length > 1
    const recaptchaEnabled = app.config.recaptcha.enabled

    return (
      <div
        className={classnames('page-detail', `page-detail-${this._pageIdent}`, {
          showrightsidebar: this.isRightSidebarOpen(),
          devmode: app.isDevModeEnabled()
        })}
      >
        <div
          className={`pageinner${
            this.isSidebarCollapsed() ? ' sbarcollapsed' : ''
          }`}
        >
          {this.renderDetailSidebar()}
          <div className='pagecontent'>
            {this.renderHeader()}
            {this.renderContent()}
          </div>
          <div className='rightsidebarcontent'>{this.renderRightSidebar()}</div>
          {!Acl.isStandardUser() &&
            this._canShowCommonAdd() &&
            this._renderCommonActions()}
          <>
            {this._bTeamTrail &&
              !app.isDemo &&
              /* eslint-disable */
              this._pageIdent !== 'setting-subscription' && (
                <DemoButton
                  title='common.team.subscribeButton'
                  onClick={this._onClickSubscribe.bind(this)}
                />
              )}
            <DialogAlert
              /* eslint-enable */
              ref={this._basePageReferences.logoutDialog}
              title='common.dialogLogout.logoutTitle'
              message='common.dialogLogout.logoutInfo'
              onOk={this._onClickLogout.bind(this)}
              showSwitchAccount={bMultipleTeams}
              onSwitchAccount={this._onClickSwitchAccount.bind(this)}
            />
            <Alert ref={this._basePageReferences.alert} />
            {this._renderDialogTimeCardAdd()}
            {this._renderTeamSelect()}
            {this._renderFABButton()}
            {this._renderUpgradeDialog()}
            {app.isDemo && (
              <DemoButton
                title='common.demosignup.title'
                onClick={this._onClickSignup.bind(this)}
              />
            )}
            <DialogTrail
              ref={this._basePageReferences.dialogTrail}
              recaptchaEnabled={recaptchaEnabled}
              onSubmit={this._onSubmitDemoRegister.bind(this)}
              onUpdateEmail={this._onUpdateDemoEmail.bind(this)}
              onResendEmail={this._onResendDemoEmail.bind(this)}
              onShowError={this._onShowError.bind(this)}
              onClose={this._onCloseDialogTrail.bind(this)}
              checkUserExists={this._checkUserExists.bind(this)}
            />
          </>
        </div>
      </div>
    )
  }

  showRightSidebar () {
    this._showRightSidebar = true
    this.setState({ dataDate: new Date() })
  }

  isRightSidebarOpen () {
    return this._showRightSidebar
  }

  hideRightSidebar () {
    this._showRightSidebar = false
    this.setState({ dataDate: new Date() })
  }

  isSidebarCollapsed () {
    return SidebarUtil.getSidebarExpand()
  }

  canShowCollapse () {
    return true
  }

  /* Sidebar Events */
  _onClickDemoLogo () {
    const config = app.getConfig()
    if (config && config.siteurl) {
      window.location.href = config.siteurl + '/?demo=true'
    }
  }

  /* Data functions */
  _getProjectBudgetItems (projectId, query, callback) {
    const params = {}

    params.query = query || {}
    params.query.projectId = projectId
    params.query.$client = {
      subObjects: {
        project: ['budget']
      }
    }

    app
      .service('/api/project/budgetitem')
      .find(params)
      .then(apiRes => {
        callback(apiRes.data || [])
      })
      .catch(() => {
        callback([]) // eslint-disable-line standard/no-callback-literal
      })
  }

  _onSearchUsers (
    mode,
    keywords,
    projectId,
    fromDate,
    toDate,
    currUserId,
    callback
  ) {
    const params = {
      query: {
        keywords: keywords.map(val => val.toLowerCase()),
        mode: mode,
        fromDate: fromDate,
        toDate: toDate,
        clientTimezoneOffset: DateUtil.getLocalTimezoneOffset(),
        includeUserIds: currUserId && keywords.length > 0 ? [currUserId] : []
      }
    }

    if (projectId) {
      params.query.projectId = projectId
    }

    app
      .service('/api/project/plannersearch')
      .find(params)
      .then(searchRes => {
        callback(searchRes.data)
      })
      .catch(err => {
        app.debug('PageProjectViewPlanner: _onSearchUsers Error', err)
        callback([]) // eslint-disable-line standard/no-callback-literal
      })
  }

  /* Render functions */
  renderContent () {
    return null
  }

  _canShowCommonAdd () {
    return true
  }

  _renderCommonActions () {
    return null
  }

  renderDetailSidebar () {
    const teams = this._getUserTeamList()

    return (
      <Sidebar
        navigateTo={this._onChangeSidebar.bind(this)}
        pageId={this._sidebarIdent}
        isMobile={app.isMobile}
        isCollapsed={this.isSidebarCollapsed()}
        teams={teams}
        activeTeamId={app.teamId}
        showTimer={app.hasUserTask}
        showRecurringInvoice={app.hasRecurringInvoice}
        pin={this._onCollapse.bind(this)}
        isDemo={app.isDemo}
        onClickDemoLogo={this._onClickDemoLogo.bind(this)}
        changeTeam={this._onChangeTeam}
        toggleDevMode={app.canAccessDevMode() ? this._onToggleDevMode.bind(this) : null}
      />
    )
  }

  renderHeader () {
    return null
  }

  /* Private functions */
  _onChangeHeaderTab (tabObj) {
    if (tabObj && tabObj.ident) {
      app.changePage(tabObj.ident)
    }
  }

  renderRightSidebar () {
    return null
  }
}

export default PageDetail
